var map = {
	"./asscher.png": 754,
	"./asscher@2x.png": 303,
	"./cushion.png": 755,
	"./cushion@2x.png": 304,
	"./emerald.png": 756,
	"./emerald@2x.png": 305,
	"./heart.png": 757,
	"./heart@2x.png": 306,
	"./marquise.png": 758,
	"./marquise@2x.png": 307,
	"./oval.png": 759,
	"./oval@2x.png": 308,
	"./pear.png": 760,
	"./pear@2x.png": 309,
	"./princess.png": 761,
	"./princess@2x.png": 310,
	"./radiant.png": 762,
	"./radiant@2x.png": 311,
	"./round.png": 763,
	"./round@2x.png": 312,
	"./trilliant.png": 764,
	"./trilliant@2x.png": 313
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 498;



//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-shapes/images ^\.\/.*\.png$
// module id = 498
// module chunks = 0